import {
  SSP_AD_MODES,
  SSP_PARTNER_AD_MODES,
  WEB_AUTO_LOGIN,
  YANDEX_AD_MODES,
} from '@web-catalog/types/omicron';

import {
  ConfigSchema,
  getBoolean,
  getString,
  getStringUnion,
  InferConfigType,
  OmicronConfigResponseType,
  WithTypeCheck,
} from '@utils/omicron';

import {
  NewMainPageBlocksOrderConfigValidator,
  RoundingRulesValidator,
} from './customValidators';

export const OmicronConfigSchema = {
  IS_SHOW_APP_CARD_RATING: {
    value: getBoolean(),
    description: 'Флаг включает отображение рейтинга приложения в списке',
    team: 'Growth',
  },
  WEB_TECHNICAL_WORKS: {
    value: getBoolean(),
    description: 'Флаг включает режим технических работ для витрины',
    team: 'Growth',
  },
  WEB_AUTO_DOWNLOAD: {
    value: getBoolean(),
    description:
      'Флаг включает автоматическую загрузку при нажатии на кнопку установки',
    team: 'Growth',
  },
  RULES_FOR_DOWNLOADS_COUNT_GAMES: {
    value: RoundingRulesValidator,
    description: 'Правило округления количества скачиваний игр для игр',
    team: 'Growth',
  },
  RULES_FOR_DOWNLOADS_COUNT_APPS: {
    value: RoundingRulesValidator,
    description:
      'Правило округления количества скачиваний приложений для приложений',
    team: 'Growth',
  },
  WEB_SIMILAR_APPS_DISCLAIMER: {
    value: getBoolean(),
    description:
      'Флаг включает дисклеймер об использовании рекомендательных систем',
    team: 'Growth',
  },
  WEB_SEARCH_EXPS: {
    value: getString(),
    description:
      'Параметр для проведения A/B тестирования поиска. Значение тогла передается в headers в запросах к backend',
    team: 'Growth',
  },
  WEB_YANDEX_AD_MODE: {
    value: getStringUnion('none', YANDEX_AD_MODES),
    description: 'Режимы рекламы Яндекса в витрине',
    team: 'Growth',
  },
  WEB_AUTO_LOGIN: {
    value: getStringUnion('none', WEB_AUTO_LOGIN),
    description:
      'Флаг на доступность и тип отображения автологина на веб витрине',
    team: 'Growth',
  },
  WEB_SHOW_HIDDEN_APP_IN_CATALOG: {
    value: getBoolean(),
    description:
      'Флаг разрешает показывать или нет карточку скрытого приложения на веб-витрине',
    team: 'Growth',
  },
  WEB_ENABLE_FEATURING: {
    value: getBoolean(),
    description: 'Флаг на разрешение показа подборок на сервисе веб витрины',
    team: 'Growth',
  },
  WEB_SHOW_APP_STUBS_IN_CATALOG: {
    value: getBoolean(),
    description:
      'Заглушки для не размещенных в RuStore приложений из страпи в веб-витрине ',
    team: 'Growth',
  },
  WEB_ENABLE_IMAGE_PROXY: {
    value: getBoolean(),
    description: 'Флаг на включение проксирования изображений',
    team: 'Growth',
  },
  WEB_ENABLE_SELECTIONS_STRAPI: {
    value: getBoolean(),
    description:
      'Флаг на включение подмешивания приложений из страпи в подборку "Возможно вам понравится" на странице приложения',
    team: 'Growth',
  },
  WEB_SSP_AD_MODE: {
    value: getStringUnion('none', SSP_AD_MODES),
    description: 'Флаг на отображение типа рекламы SSP',
    team: 'Ads',
  },
  WEB_SSP_AD_PARTNER: {
    value: getStringUnion('none', SSP_PARTNER_AD_MODES),
    description: 'Флаг типа партнеров рекламы SSP',
    team: 'Ads',
  },
  WEB_SSP_AD_WITH_AUTH: {
    value: getBoolean(),
    description:
      'Отправка запроса(и показ баннера в случае успеха) на ssp рекламу в витрине только с авторизированными юзерами с vk id',
    team: 'Ads',
  },
  WEB_SSP_SCRIPT_ENABLED: {
    value: getBoolean(),
    description:
      'Флаг на переключение реализации ssp рекламы с next на внешний скрипт',
    team: 'Ads',
  },
  WEB_YANDEX_AD_LEFT_SIDEBAR_ENABLED: {
    value: getBoolean(),
    description:
      'Флаг на показ рекламы РСЯ на большом десктопе главной страницы под списком категорий',
    team: 'Growth',
  },
  WEB_YANDEX_AD_RIGHT_SIDEBAR_ENABLED: {
    value: getBoolean(),
    description:
      'Флаг на показ рекламы РСЯ справа на большом десктопе страницы приложения',
    team: 'Growth',
  },
  WEB_YANDEX_AD_APPS_LIST_ENABLED: {
    value: getBoolean(),
    description:
      'Флаг на подмешивание рекламы в списках приложений в категориях',
    team: 'Growth',
  },
  WEB_ENABLE_QR_INSTALL: {
    value: getBoolean(),
    description: 'Флаг включения кнопки установки через QR',
    team: 'Growth',
  },
  WEB_GAME_MARKINGS_ENABLED: {
    value: getBoolean(),
    description:
      'Флаг отображения возрастной маркировки для игр в карточке приложения + страницы с возрастной маркировкой',
    team: 'Phoenix',
  },
  WEB_ENABLE_HIDDEN_EXCEPTIONS: {
    value: getBoolean(),
    description:
      'Флаг на включение и выключение исключений для скрытых приложений в Strapi',
    team: 'Growth',
  },
  WEB_SEARCH_TAGS_ENABLED: {
    value: getBoolean(),
    description: 'Флаг на отображение тегов приложений',
    team: 'Growth',
  },
  WEB_ENABLE_NEW_DEEPLINK: {
    value: getBoolean(),
    description:
      'Флаг на включение нового диплинка на инструкцию с плашкой с кнопки "Установить с помощью RuStore"',
    team: 'Growth',
  },
  WEB_ENABLE_NEW_SCHEME_DEEPLINK: {
    value: getBoolean(),
    description:
      'Флаг на включение новой схемы диплинка на карточку приложения для ссылки "Установить с помощью RuStore"',
    team: 'Larek',
  },
  WEB_ENABLE_SELECTIONS_ON_MAIN: {
    value: getBoolean(),
    description: 'Флаг на включение новой главной с подборками',
    team: 'Growth',
  },
  WEB_SELECTIONS_ON_MAIN_BLOCK_ORDER: {
    value: NewMainPageBlocksOrderConfigValidator,
    description: 'Конфиг на порядок блоков на новой главной',
    team: 'Growth',
  },
  WEB_SHOW_VIDEO_IN_APP_SCREENSHOTS: {
    value: getBoolean(),
    description: 'Флаг на добавление видео в карусель скриншотов',
    team: 'Growth',
  },
  WEB_ENABLE_EVENTS_ON_MAIN: {
    value: getBoolean(),
    description: 'Флаг на показ блока с событиями на главной',
    team: 'Growth',
  },
  WEB_ENABLE_PREORDER_REDESIGN: {
    value: getBoolean(),
    description: 'Флаг редизайна подборок с предзаказами',
    team: 'Growth',
  },
} satisfies ConfigSchema;

export type OmicronContent = InferConfigType<
  WithTypeCheck<typeof OmicronConfigSchema>
>;

export type OmicronFlags = keyof typeof OmicronConfigSchema;

export type OmicronDTO = OmicronConfigResponseType<OmicronContent>;
